import { render, staticRenderFns } from "./DocumentItemCard.vue?vue&type=template&id=70d3b3f7&scoped=true"
import script from "./DocumentItemCard.vue?vue&type=script&lang=js"
export * from "./DocumentItemCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d3b3f7",
  null
  
)

export default component.exports